import * as actions from "actions/login";

export default (state = null, { type, payload }) => {
  switch (type) {
    case actions.AUTHENTICATE_SUCCESS:
    case actions.LOGIN_SUCCESS:
      return payload.data;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/login/user.js